import { colors, fonts } from 'components/styles/variables';
import css from 'styled-jsx/css';

export const saveClearSearchButtonsStyles = css`
  .cta-row {
    display: flex;
    flex-direction: row;
    border-radius: 8px;
  }

  .cta-row :global(.clear-filter-button) {
    border: 1px solid ${colors.G2} !important;
    color: ${colors.BLACK} !important;
    font-family: ${fonts.default} !important;
    font-weight: 600 !important;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px !important;
    text-transform: none;
    border-radius: 4px !important;
    height: 32px;
  }
  @media (min-width: 600px) {
    .cta-row {
      background: white;
      justify-content: space-between;
      padding: 8px;
    }
    .cta-row :global(button) {
      width: 135px;
    }
  }
  .mobile-drawer {
    padding: 0 0 16px 0;
    justify-content: space-around;
  }
  .mobile-drawer :global(button) {
    width: calc((100% - 48px) / 2);
  }
`;
